export default function Footer()
{
    return(
        <footer className="footer">
            <p>Copyright © 2024 – YJC and Wellness All Rights Reserved.</p>
        </footer>
    )
}
